
import {useEffect} from 'react';

const useAddThisShare = (divRef, onShareCallback) => {
    useEffect(() => {
        const ref = divRef.current;

        if (ref) {
            ref.addEventListener(`addthis.menu.share`, onShareCallback);
        }

        return () => {
            if(ref) {
                ref.removeEventListener(`addthis.menu.share`, onShareCallback);
            }
        };
    }, [divRef, onShareCallback]);
};

export {useAddThisShare};
